export default {
  title: 'Communication preferences',
  informationsLabel: 'Subscribing to electronic services allows you to consult information about your products securely and at a time that suits you.',
  documentPreferences: {
    sectionTitle: 'Documents',
    textPart1: 'Several ',
    textPart2: 'documents are available online',
    textPart3: ' and more will be added as they become available in electronic format. Documents that are not available online will be sent to you by mail.',
    option1: 'Online',
    option2: 'By mail',
  },
  communicationPreference: {
    option1: 'By email',
    option2: 'By mail',
    sectionTitle: 'Communications and follow-ups',
    label: 'Exchange of information and follow-up of files in connection with your contracts',
  },
  subscribeToDocumentNotification: {
    label: 'Email notifications',
    text: 'I would like to receive an email notification when a new document is available.',
  },
  termsOfUse: {
    textPart1: 'I have read and accept ',
    textPart2: 'the terms and conditions of use',
    textPart3: '.',
    modalTitle: 'Terms and conditions of use',
  },
};
